export default function About() {
  return (
    <section id="about" className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">About Renoboys</h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-4 sm:mb-6"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">Your Trusted Auckland Building Partner</h3>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              Based in Kingsland and servicing the entire Auckland region, Renoboys is your go-to team for all building and renovation needs. We're not just contractors – we're your neighbours who take pride in transforming houses into homes.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              With years of experience in commercial and residential projects, we bring expertise, reliability, and a personal touch to every job. From concept to completion, we work closely with you to ensure your vision becomes reality. For all Restricted Building Work, we co-ordinate with appropriately licensed contractors to ensure full compliance and quality workmanship.
            </p>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <div className="flex items-center gap-2 bg-orange-50 px-4 py-2.5 rounded-lg">
                <i className="ri-checkbox-circle-fill text-orange-500 text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base font-medium text-gray-700">Fully Insured</span>
              </div>
              <div className="flex items-center gap-2 bg-orange-50 px-4 py-2.5 rounded-lg">
                <i className="ri-checkbox-circle-fill text-orange-500 text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base font-medium text-gray-700">Coordinates Licensed Tradespeople</span>
              </div>
              <div className="flex items-center gap-2 bg-orange-50 px-4 py-2.5 rounded-lg">
                <i className="ri-checkbox-circle-fill text-orange-500 text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base font-medium text-gray-700">Quality Guaranteed</span>
              </div>
              <div className="flex items-center gap-2 bg-orange-50 px-4 py-2.5 rounded-lg">
                <i className="ri-checkbox-circle-fill text-orange-500 text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base font-medium text-gray-700">Local Experts</span>
              </div>
              <div className="flex items-center gap-2 bg-orange-50 px-4 py-2.5 rounded-lg">
                <i className="ri-checkbox-circle-fill text-orange-500 text-lg sm:text-xl"></i>
                <span className="text-sm sm:text-base font-medium text-gray-700">10 Year Build Warranty</span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative h-80 sm:h-96 lg:h-full lg:min-h-[500px] rounded-xl overflow-hidden shadow-xl">
              <img
                src="https://static.wixstatic.com/media/288b4c_002140ef5d9e45e583ddfe7c98963115~mv2.jpg/v1/fill/w_568,h_427,al_c,q_80,usm_0.66_1.00_0.01/288b4c_002140ef5d9e45e583ddfe7c98963115~mv2.jpg"
                alt="Renoboys Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="text-center p-6 sm:p-8 bg-white rounded-xl shadow-md">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-2xl sm:text-3xl text-orange-500"></i>
            </div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Expert Team</h4>
            <p className="text-sm sm:text-base text-gray-600">Skilled professionals dedicated to excellence</p>
          </div>

          <div className="text-center p-6 sm:p-8 bg-white rounded-xl shadow-md">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl sm:text-3xl text-orange-500"></i>
            </div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Quality Work</h4>
            <p className="text-sm sm:text-base text-gray-600">Craftsmanship you can see and trust</p>
          </div>

          <div className="text-center p-6 sm:p-8 bg-white rounded-xl shadow-md">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl sm:text-3xl text-orange-500"></i>
            </div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">On Time</h4>
            <p className="text-sm sm:text-base text-gray-600">Projects completed within agreed timelines</p>
          </div>

          <div className="text-center p-6 sm:p-8 bg-white rounded-xl shadow-md">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-2xl sm:text-3xl text-orange-500"></i>
            </div>
            <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Great Service</h4>
            <p className="text-sm sm:text-base text-gray-600">Customer satisfaction is our priority</p>
          </div>
        </div>
      </div>
    </section>
  );
}